import { library } from "@fortawesome/fontawesome-svg-core";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import {
  BenefitBody,
  BenefitContainer,
  BenefitTitle,
  FontAwesomeIconStyled,
} from "../styles";

export default function SingleBenefitBox(props) {
  const { jobBenefit } = props;

  const iconList = Object.keys(Icons)
    .filter((key) => key !== "fas" && key !== "prefix")
    .map((icon) => Icons[icon]);

  library.add(...iconList);

  const replaceIcon = (iconCode) => {
    if (iconCode === "money") {
      iconCode = "money-bill-alt";
    } else if (iconCode === "clock-o") {
      iconCode = "clock";
    }
    return iconCode;
  };

  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    setShowIcon(true);
  }, []);

  // Memo this component so that it won't have to re-render title and description because "showIcon" state changes
  const MemoJobTitle = React.memo(BenefitTitle);
  const MemoJobBody = React.memo(BenefitBody);

  return (
    <BenefitContainer
      item
      container
      flexDirection={"column"}
      alignItems={"flex-start"}
    >
      {showIcon === true && (jobBenefit.iconCode || jobBenefit.icon_code) ? (
        <FontAwesomeIconStyled
          icon={replaceIcon(jobBenefit.iconCode || jobBenefit.icon_code)}
        />
      ) : null}
      <MemoJobTitle variant="h1">{jobBenefit?.title ?? ""}</MemoJobTitle>
      <MemoJobBody variant="body1">{jobBenefit?.description ?? ""}</MemoJobBody>
    </BenefitContainer>
  );
}
